export enum CargoStatus {
  Open = 'Open',
  Poss = 'Poss',
  OnSubs = 'On Subs',
  Fixed = 'Fixed',
  Withdrawn = 'Withdrawn',
  Failed = 'Failed',
  OnHold = 'On Hold',
  Archived = 'Archived',
}

export const quickEditStatusOptions = [
  CargoStatus.OnSubs,
  CargoStatus.Fixed,
  CargoStatus.Failed,
  CargoStatus.Withdrawn,
  CargoStatus.OnHold,
]

export const statusOptions = Object.values(CargoStatus).filter(
  (status) => status !== CargoStatus.Archived,
)

export const quantityUnitOptions = ['MT', 'CBM', 'BBL']
const rateOptions = ['WS', 'LS', 'USD/MT', 'Individual'] as const
export type RateOption = (typeof rateOptions)[number]

export const getRateOptions = ({
  withIndividualOption,
}: {
  withIndividualOption?: boolean
} = {}): RateOption[] =>
  withIndividualOption
    ? [...rateOptions]
    : rateOptions.filter((option) => option !== 'Individual')

export const periodOptions = ['Months', 'Days']
